var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRank3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M35.7168 14.8463C37.4586 24.6309 30.9399 33.9768 21.1529 35.7186C19.8155 35.9567 18.4872 36.0407 17.1841 35.982C15.5466 35.9102 13.9508 35.6134 12.4332 35.1184C11.0788 34.6773 9.78629 34.0763 8.58268 33.3367C8.21492 33.1108 7.85449 32.8719 7.50384 32.6191C5.96264 31.5133 4.59595 30.1654 3.4641 28.6185C3.24311 28.3167 3.03028 28.0069 2.82886 27.6905C1.59182 25.757 0.707061 23.5529 0.279765 21.1538C0.240623 20.9345 0.206368 20.7143 0.177012 20.4933C-1.16685 10.9517 5.27848 1.98418 14.8437 0.28152C17.1979 -0.137622 19.526 -0.0780784 21.7286 0.389175C22.1542 0.47969 22.575 0.584884 22.9909 0.705571C24.8061 1.23072 26.5185 2.03801 28.0671 3.08424C28.4088 3.31501 28.7415 3.55637 29.0668 3.80998C30.2231 4.71105 31.2702 5.75319 32.181 6.91684C33.1196 8.11637 33.9131 9.44556 34.5304 10.8816C34.9805 11.9302 35.3368 13.036 35.5856 14.1907C35.6353 14.4084 35.6785 14.6269 35.7168 14.8463Z",
    fill: "url(#paint0_linear_1_7037)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M34.531 10.8807L17.1839 35.9812C15.5465 35.9094 13.9507 35.6126 12.4331 35.1176L32.1817 6.91602C33.1211 8.11554 33.9146 9.44473 34.531 10.8807Z",
    fill: "#F2F0AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M22.9916 0.705067L3.46483 28.6188C3.24384 28.3171 3.03101 28.0072 2.82959 27.6908L21.7293 0.388672C22.155 0.479187 22.5758 0.584381 22.9916 0.705067Z",
    fill: "#F2F0AC"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M29.0677 3.80972L8.58275 33.3372C8.21498 33.1114 7.85455 32.8724 7.50391 32.6196L28.0672 3.08398C28.4096 3.31476 28.7423 3.55612 29.0677 3.80972Z",
    fill: "#F2F0AC"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M32.1605 15.48C32.1997 15.6977 32.2323 15.9155 32.2624 16.1324C33.2573 23.7022 28.1118 30.8113 20.5199 32.1625C12.9281 33.5137 5.6453 28.6169 3.9671 21.1694C3.92062 20.9558 3.87659 20.7389 3.83745 20.5219C2.44711 12.7132 7.66925 5.22977 15.478 3.83943C23.2868 2.44908 30.7702 7.67041 32.1605 15.48Z",
    fill: "#932C11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M32.2628 16.131C33.2577 23.7008 28.1122 30.8099 20.5203 32.1611C20.3507 32.1913 20.1819 32.2174 20.0131 32.241C18.3088 32.4832 16.6274 32.4139 15.025 32.073C13.4235 31.7322 11.9043 31.1222 10.527 30.2823C10.1772 30.0695 9.83711 29.8428 9.50441 29.5998C7.99909 28.4956 6.70334 27.1037 5.71582 25.4817C5.47771 25.0944 5.25673 24.6908 5.05694 24.2781C4.58153 23.3045 4.21457 22.2632 3.96668 21.1672C2.97183 13.5973 8.11733 6.48661 15.7092 5.13541C16.6698 4.96416 17.6255 4.89402 18.5673 4.91604C19.046 4.92664 19.523 4.96172 19.9944 5.02043C21.918 5.25936 23.7504 5.88481 25.3927 6.82992C25.7466 7.03378 26.0939 7.25312 26.4315 7.48879C27.7412 8.3972 28.9016 9.52172 29.8524 10.8224C30.7795 12.0904 31.5069 13.5223 31.9848 15.0823C32.0908 15.4256 32.1837 15.7762 32.2628 16.131Z",
    fill: "url(#paint1_linear_1_7037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M12.1403 11.9844C13.0895 10.9561 15.3842 9.47852 17.7849 9.47852C22.0839 9.47852 24.5099 11.6941 24.5099 15.0701C24.5099 16.8632 23.2443 17.8923 22.5585 18.4199C23.4025 19.0266 25.0114 20.3713 25.0114 22.7451C25.0114 26.6486 21.266 28.5478 17.7058 28.5478C15.1999 28.5478 12.5888 27.0971 11.5605 25.5674L14.2507 22.7712C15.2268 23.7473 16.229 24.4861 17.7319 24.4861C19.2087 24.4861 20.1057 23.7734 20.1057 22.4548C20.1057 21.0302 19.2356 20.5295 17.9162 20.5295H15.9379V17.3908H17.8632C19.1288 17.3908 20.1048 16.7581 20.1048 15.5708C20.1048 14.1462 18.8915 13.4873 17.7841 13.4873C16.7819 13.4873 15.6215 14.094 14.6984 15.0701L12.1403 11.9844Z",
    fill: "#932C11"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M12.1403 11.0723C13.0895 10.0432 15.3842 8.56641 17.7849 8.56641C22.0839 8.56641 24.5099 10.782 24.5099 14.158C24.5099 15.9511 23.2443 16.9794 22.5585 17.507C23.4025 18.1137 25.0114 19.4584 25.0114 21.8321C25.0114 25.7357 21.266 27.6349 17.7058 27.6349C15.1999 27.6349 12.5888 26.1842 11.5605 24.6544L14.2507 21.8583C15.2268 22.8343 16.229 23.5723 17.7319 23.5723C19.2087 23.5723 20.1057 22.8604 20.1057 21.5419C20.1057 20.1173 19.2356 19.6166 17.9162 19.6166H15.9379V16.4779H17.8632C19.1288 16.4779 20.1048 15.8451 20.1048 14.6578C20.1048 13.2332 18.8915 12.5743 17.7841 12.5743C16.7819 12.5743 15.6215 13.181 14.6984 14.1571L12.1403 11.0723Z",
    fill: "url(#paint2_linear_1_7037)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M31.9847 15.083L20.013 32.2401C18.3087 32.4823 16.6273 32.413 15.0249 32.0721L29.8523 10.8223C30.7794 12.0903 31.5068 13.5222 31.9847 15.083Z",
    fill: "#F2F0AC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M19.9941 5.02316L5.71552 25.4837C5.47741 25.0963 5.25643 24.6927 5.05664 24.2801L18.567 4.91797C19.0457 4.92939 19.5227 4.96445 19.9941 5.02316Z",
    fill: "#F2F0AC"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M26.4312 7.49286L10.5275 30.2855C10.1776 30.0727 9.83759 29.846 9.50488 29.603L25.3931 6.83398C25.7462 7.03785 26.0936 7.25719 26.4312 7.49286Z",
    fill: "#F2F0AC"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_7037",
    x1: 17.9997,
    y1: 0.144123,
    x2: 17.9997,
    y2: 59.0434,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D66B11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_7037",
    x1: 18.1151,
    y1: 47.8467,
    x2: 18.1151,
    y2: -5.53348,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#932C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D66B11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_7037",
    x1: 18.2857,
    y1: 11.2561,
    x2: 18.2857,
    y2: 24.5491,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FC9E00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D66B11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRank3);
export default __webpack_public_path__ + "static/media/rank-3.ec98f694b3f1a35114b439dc40b1317f.svg";
export { ForwardRef as ReactComponent };